/**
 * Carries the pre-sign-in location across the OIDC redirect round-trip.
 *
 * `signIn` sends the current path as `url_state`; the callback stashes it here
 * (sessionStorage — per-tab, survives the redirect) and `CallbackRoute`
 * consumes it to land the user back where they started. Storage is injected so
 * the logic is unit-testable in the node environment.
 */

const STORAGE_KEY = 'pm.postSignInPath';

// Only same-origin relative paths: must start with a single '/'. Anything else
// ('//evil.example', 'https://…', garbage) is dropped to avoid an open redirect.
const isSafeRelativePath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//');

export const stashPostSignInPath = (path: string | undefined, storage: Storage): void => {
  if (path !== undefined && isSafeRelativePath(path)) {
    storage.setItem(STORAGE_KEY, path);
  }
};

export const consumePostSignInPath = (storage: Storage): string | null => {
  const path = storage.getItem(STORAGE_KEY);
  storage.removeItem(STORAGE_KEY);
  return path !== null && isSafeRelativePath(path) ? path : null;
};
